// extracted by mini-css-extract-plugin
export default {"todoform":"form_todoform__++BbZ","moderInput":"form_moderInput__5UGuf","moderButton":"form_moderButton__Z8MRE","inputContainer":"form_inputContainer__MCWnn"};